import "react-calendar/dist/Calendar.css";
import styles from "./index.module.scss";
import classes from "classnames";
import Calendar, {
  CalendarProps,
  TileClassNameFunc,
  TileDisabledFunc,
} from "react-calendar";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { getChallengeCalendar } from "../../../../api";

export interface ChallengeCalendarProps {
  className?: string;
}

const ChallengeCalendar = ({ className }: ChallengeCalendarProps) => {
  const [calendar, setCalendar] = useState<Record<string, any>[]>([]);

  useEffect(() => {
    getChallengeCalendar(dayjs().format("YYYYMM")).then((data) => {
      setCalendar(data);
    });
  }, []);

  const handleTileDisabled: TileDisabledFunc = ({ date }) => {
    return !dayjs(date).isSame(new Date(), "month");
  };

  const handleActiveStartDateChange: CalendarProps["onActiveStartDateChange"] =
    ({ activeStartDate }) => {
      setCalendar([]);
      const month = dayjs(activeStartDate).format("YYYYMM");
      getChallengeCalendar(month).then((data) => {
        setCalendar(data);
      });
    };

  const generateTileClassName: TileClassNameFunc = ({ date }) => {
    const current = calendar.find((c) => c.day === dayjs(date).format("D"));
    if (dayjs(date).isAfter(new Date(), "date")) {
      return styles.tileClassName;
    }
    if (current?.code_num > 0) {
      return classes(styles.tileClassName, styles.done);
    }
    return classes(styles.tileClassName, styles.undo);
  };

  // console.log(calendar);

  return (
    <div className={classes(styles.challengeCalendar, className)}>
      <div className={styles.header}>
        <div className={styles.title}>挑战日历</div>
      </div>
      <Calendar
        className={styles.main}
        value={new Date()}
        formatDay={(_, date) => dayjs(date).format("D")}
        locale="zh-CN"
        tileClassName={generateTileClassName}
        tileDisabled={handleTileDisabled}
        onActiveStartDateChange={handleActiveStartDateChange}
        maxDate={new Date()}
      />
    </div>
  );
};

export default ChallengeCalendar;
